import {
    CLIPS_DOWNLOAD
} from '../actions';

import Crud, { Nihilism } from '@/api/crud';

const DEFAULT_STATE = {

};

const getters = {
}

const actions = {
    async [CLIPS_DOWNLOAD]({ }, { rootTitleId, clipId, language }) {
        const path = `/clfinder/shows/${rootTitleId}/clips/${clipId}/url`;
        const api = new Crud(new Nihilism(path));
        const { url } = await api.load({ language: language });
        window.location = url;
    }
}

const mutations = {
}

export default {
    state: { ...DEFAULT_STATE },
    getters,
    actions,
    mutations
};